import { TYPES } from "../actions";

const initialState = {
  trustedStories: [],
  totalCount: 0,
  currentStory: null,
  templates: [],
  searchResults: [],
  loading: false
};

export const tkt1TrustedStoryReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORIES_SUCCESS:
      return { 
        ...state, 
        trustedStories: action.payload.data.data, 
        totalCount: action.payload.data.pagination ? action.payload.data.pagination.total_count : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORIES_FAIL:
      return { 
        ...state, 
        trustedStories: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentStory: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_FAIL:
      return { 
        ...state, 
        currentStory: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_SUCCESS:
      return { 
        ...state, 
        currentStory: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_FAIL:
      return { 
        ...state, 
        currentStory: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_SUCCESS:
      return { 
        ...state, 
        templates: action.payload.data.data || action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_FAIL:
      return { 
        ...state, 
        templates: [],
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_TRUSTED_STORIES_SUCCESS:
      return { 
        ...state, 
        searchResults: action.payload.data.data || action.payload.data,
        loading: false
      };

    case TYPES.ACTION_SEARCH_TKT1_TRUSTED_STORIES_FAIL:
      return { 
        ...state, 
        searchResults: [],
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_TRUSTED_STORY_SUCCESS:
      return { 
        ...state, 
        trustedStories: [action.payload.data, ...state.trustedStories],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_TRUSTED_STORY_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_STORY_SUCCESS:
      return { 
        ...state, 
        trustedStories: state.trustedStories.map(story => 
          story._id === action.payload.data._id ? action.payload.data : story
        ),
        currentStory: state.currentStory && state.currentStory._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentStory,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_TRUSTED_STORY_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_TRUSTED_STORY_SUCCESS:
      return { 
        ...state, 
        trustedStories: state.trustedStories.filter(story => story._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentStory: state.currentStory && state.currentStory._id === action.payload.id 
          ? null 
          : state.currentStory,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_TRUSTED_STORY_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
